module.exports = __webpack_public_path__ + "img/Kristin-Lavransdatter_Bilde-under-Egenviljen-og-gudsviljen.b79e5476.jpg";